<template>
  <div>
    <navigation-menu />
    <v-toolbar
      class="red darken-2"
      dark
      fixed
      app
    >
      <v-toolbar-title class="headline font-weight-regular">B.Account Admin panel</v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          id="logout"
          flat
          @click="onLogoutButtonClick"
        >
          <v-icon>power_settings_new</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import NavigationMenu from '@/components/layout/NavigationMenu'

  export default {
    name: 'Navigation',
    components: {
      NavigationMenu
    },
    inject: ['endCurrentUserSession'],
    methods: {
      ...mapActions('modal', ['showModal']),
      onLogoutButtonClick () {
        this.endCurrentUserSession()
      }
    }
  }
</script>

<style>
  .v-toolbar__items .v-btn {
    min-width: 58px;
  }
</style>
